import React, { useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import useForm from "../../../../../js/custom-hooks/useForm";
import validate from "./modeling-form.validationRules";
import TextInput from "../../../form-inputs/text-input/text-input.component";
import CustomButton from "../../../custom-button/custom-button.component";
import { left_title, link, right_title, versionData } from "./modeling-form.data";
import "./modeling-form.styles.scss";
import { ListOfFormUniqueData } from "../../../helpers/form-uniqueid/form-uniqueid";
import { useSelector } from "react-redux";
import { handleNotify } from "../../../../../js/helpers/toaster/toaster-notify";
import { ToasterPositions } from "../../../../../js/helpers/toaster/toaster-positions";
import { ToasterTypes } from "../../../../../js/helpers/toaster/toaster-types";
import Recaptcha from "../../../recaptcha/recaptcha.component";
import { createToken } from "../../../../../js/api/_azure-queue.data";
import { submitNewRemoteModelingJob } from "../../../../../js/api/modelingforms/_submitRemoteModeling.data";
import { useHistory } from "react-router-dom";

const ModelingForm = ({ mainData, status, onFormSubmit, remotemodeling }) => {

    const history = useHistory();

    //#RP - Task 72 - Submit Remote modeling
    const [fileData, setFile] = useState(null);
    const [remotemodelingversiondata, setRemotemodelingversiondata] = useState(remotemodeling);
    var selectedversion = remotemodeling && remotemodeling.find(x => x.DefaultValue !== null && x.DefaultValue !== "");
    const [version, setVersion] = useState(selectedversion != undefined && selectedversion != null && selectedversion.Title);

    const brmsKey = useSelector(({ client }) => client.brmsKey);
    const { values, errors, handleChange, handleSubmit } = useForm(
        submitSuccess,
        validate
    );

    const onfileChange = (e) => {
        if (e.target.files != null && e.target.files.length > 0)
            setFile(e.target.files[0]);
    }

    const onRadioChange = (e) => {
        if (e.currentTarget.value != null)
            setVersion(e.currentTarget.value);
    }

    const submitData = async (submissionObj) => {
        if (submissionObj) {
            const token = await createToken();
            await submitNewRemoteModelingJob(submissionObj, token);
            onFormSubmit()
            history.push('/software/thank-you-page')
        }
    };

    async function submitSuccess() {
        if (Object.keys(brmsKey).length === 0) {
            handleNotify('BRMS key not present.', ToasterTypes.Warning);
        } else {
            const formData = new FormData();
            formData.set('EmailAddress', values.email.trim());
            formData.set('BRMSKey', brmsKey);
            formData.set("Version", version);
            formData.set("ProjectName", values.projectName != null ? values.projectName.trim() : "None");
            formData.set("NotifyEmail", values.email.trim());
            formData.set("ConfirmNotifyEmail", values.email.trim());
            formData.set("Memo", values.memo != null ? values.memo.trim() : "None");
            formData.set("FormUniqueId", ListOfFormUniqueData.submit_remote_modeling_form.UniqueId);
            formData.set('BrmsFile', fileData);
            submitData(formData);
        }
    }

    return (
        <div className="modeling-form-container">
            <form className="inner-form" onSubmit={handleSubmit} noValidate>
                <Row>
                    <Col xs={12} sm={6}>
                        <p className="content-title">{mainData != null ? mainData.FormLeftSubTitle : ""}</p>
                        <p className="content">{mainData != null ? mainData.FormLeftContent : ""}</p>
                    </Col>
                    <Col xs={12} sm={6}>
                        <div className='react-file-reader'>
                            <p className="content">{mainData != null ? mainData.FormRightContent : ""}</p>
                            <input type='file'
                                className='react-file-reader-input'
                                multiple={false}
                                onChange={onfileChange}
                            />
                            <div className='react-file-reader-button'>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} sm={6}>
                        <p className="title">{left_title}</p>
                        <div className="version-container">
                            {remotemodelingversiondata && remotemodelingversiondata.map((item) => (
                                <div className="single-version-container">
                                    <input
                                        type="radio"
                                        name="Title"
                                        id={item.Title}
                                        className="version-number"
                                        value={item.Title}
                                        onChange={onRadioChange}
                                        checked={item.Title === version}                                        
                                    />
                                    <label htmlFor="Title">{item.Title}</label>
                                </div>
                            ))}
                        </div>
                    </Col>
                    <Col xs={12} sm={6}>
                        <p className="title">{right_title}</p>
                        <div className="right-form">
                            {errors.email && <span className="help">{errors.email}</span>}
                            <TextInput
                                placeholder="Email"
                                type="email"
                                name="email"
                                required={true}
                                onChange={handleChange}
                                value={values.email || ""}
                                autoComplete="off"
                                className={`${errors.email && "error"}`}
                                maxLength={100}
                            />

                            {errors.confirmEmail && (
                                <span className="help">{errors.confirmEmail}</span>
                            )}
                            <TextInput
                                placeholder="Confirm Email Address"
                                type="email"
                                name="confirmEmail"
                                required={true}
                                onChange={handleChange}
                                value={values.confirmEmail || ""}
                                autoComplete="off"
                                className={`${errors.confirmEmail && "error"}`}
                                maxLength={100}
                            />
                            {errors.projectName && (
                                <span className="help">{errors.projectName}</span>
                            )}
                            <TextInput
                                placeholder="Project Name"
                                name="projectName"
                                required={true}
                                onChange={handleChange}
                                value={values.projectName || ""}
                                autoComplete="off"
                                className={`${errors.projectName && "error"}`}
                                maxLength={200}
                            />
                            <textarea
                                name="memo"
                                placeholder="Memo"
                                onChange={handleChange}
                                value={values.memo}
                                autoComplete="off"
                                maxLength={300}
                            >
                            </textarea>
                            <div className="bottom-container">
                                <div className="recaptcha">
                                    <Recaptcha />
                                </div>
                                <div className="link">
                                    <CustomButton className="heroLink">{link}</CustomButton>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </form>
        </div>
    );
};

export default ModelingForm;
